import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'mtg-table-subtitle',
  template: '<div class="text"><ng-content></ng-content></div>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableSubtitleComponent {
  @HostBinding('class.subtitle')
  defaultClass = true;
}
